<mat-dialog-content [class]="contentClass()">
    @if (isProcessing() && processingAppearance() !== 'button') {
        <div class="loader-wrapper">
            <qpx-loader />
        </div>
    }

    <ng-content />
</mat-dialog-content>
